import { TableColumnModel } from '../tableColumsModel';
const UserIdColumn = new TableColumnModel('id', 'Id', 170, true, false);
const ClientIdColumn = new TableColumnModel('clientId', 'ClientId', 170, true, false);
const ScopesColumn = new TableColumnModel('scopesArray', 'Scopes', 170, true, false);
const UserActions = new TableColumnModel('actions', '', 170, false, true);

export const UsersTableColumns = () => {
  return [UserIdColumn, ClientIdColumn, ScopesColumn, UserActions];
};
